/**
 * Copyright © Veeam Software Group GmbH.
 */

import { BackupAgentBackupModeRepresentation } from '@veeam-vspc/models/web-controllers';

export type EndpointBackupModes = BackupAgentBackupModeRepresentation;
export const EndpointBackupModes = BackupAgentBackupModeRepresentation;
